// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"5b0d6f65","166":"1ec27bfb","455":"fded46d7","715":"ef123aa1","880":"d1684836","885":"ac68a6a2","930":"402dd9b0","977":"429e1f9d"}[chunkId] + ".chunk.js";
};